// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"lN","cardContent":"lO","editButton":"lP","innerHeading":"lQ","header":"lR","subHeader":"lS"};